import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-request-name-appear",
  templateUrl: "./card-request-name-appear.component.html",
  standalone:false,
  styleUrls: ["./card-request-name-appear.component.scss"],
})
export class CardRequestNameAppearComponent implements OnInit {
  CardRequestNameAppear;
  activeTab: number;

  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {}

  payCardSuccess() {
    this.router.navigateByUrl("/PayCardSuccess");
  }
  changeTab(e) {
    this.activeTab = e;
  }
}